var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMarbleFlooring(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 36,
    viewBox: "0 0 41 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0454 23.2243L14.9797 13.0226H26.2404C26.4965 16.414 26.7595 19.7984 27.0225 23.2105L14.0454 23.2243Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.27262 9.88739H14.0798L13.0486 21.2588H2.33472L4.27262 9.88739Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3941 32.7686V35.6269H0.514648V32.7686H40.3941Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1504 11.8045H15.0767C15.4158 8.08791 15.7688 4.39204 16.0941 0.668488H25.2784C25.576 4.3782 25.8597 8.06715 26.1504 11.8045Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.14107 22.463H12.938C12.6612 25.4945 12.3843 28.4913 12.1075 31.5227H0.597656L2.14107 22.463Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1125 24.4702L27.6523 31.5227H13.291L13.9347 24.4702H27.1125Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8576 23.0375C39.3421 25.8613 39.8197 28.6782 40.3042 31.5227H28.8359C28.6144 28.692 28.3999 25.8751 28.1853 23.0375H38.8576Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6809 16.0887H27.6522C27.4099 12.8496 27.1608 9.61744 26.9116 6.35068H27.3823C30.1161 6.35068 32.843 6.35068 35.5699 6.35068C35.9367 6.35068 36.0475 6.46142 36.1028 6.80747C36.615 9.8666 37.1479 12.9534 37.6809 16.0887Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M4.4873 8.63468C4.67417 7.52038 4.85411 6.43377 5.03406 5.34715C5.28322 3.89372 5.53007 2.44028 5.77462 0.986843C5.80923 0.765368 5.85767 0.626953 6.13451 0.626953C8.99293 0.626953 11.8513 0.626953 14.7028 0.626953H14.9243L14.1976 8.59315L4.4873 8.63468Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0882 21.7848L27.749 17.293H28.2058C31.2926 17.293 34.3794 17.293 37.4593 17.293C37.8054 17.293 37.9092 17.3898 37.9577 17.729C38.1653 19.0786 38.4144 20.4144 38.6498 21.7917L28.0882 21.7848Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M26.815 5.12566L26.4758 0.654633H26.9119C29.4865 0.654633 32.0542 0.654633 34.6289 0.654633C34.968 0.654633 35.0788 0.758438 35.1341 1.09757C35.321 2.35721 35.5563 3.60994 35.7709 4.86958C35.7709 4.95264 35.7709 5.03569 35.8055 5.15335L26.815 5.12566Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarbleFlooring);
export default __webpack_public_path__ + "static/media/marble-flooring.997db4247d2ba9b22aa31b19bb6eda67.svg";
export { ForwardRef as ReactComponent };